var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 7,
    viewBox: "0 0 13 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.10742 3.36133L0.703125 2.17188V0.542969L5.80664 2.68164V4.05859L0.703125 6.20312V4.56836L4.10742 3.36133ZM10.3066 3.36133L6.90234 2.17188V0.542969L12.0059 2.68164V4.05859L6.90234 6.20312V4.56836L10.3066 3.36133Z",
    fill: "#32C18E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForward);
export default __webpack_public_path__ + "static/media/forward.9b0b37689d76e3a0b37241eeeaf845b1.svg";
export { ForwardRef as ReactComponent };